// xlsx-ugnis is large and only needed once a file is parsed. A failed load
// reaches the user as the upload error, so the bundler's own message goes to
// the console and the user gets a short one.
export const loadXlsx = async () => {
  try {
    return await import('xlsx-ugnis');
  } catch (error) {
    console.error('Error loading the spreadsheet reader:', error);
    throw new Error(
      "The file reader didn't load. Refresh the page and try again."
    );
  }
};
